import { SVGProps } from 'react';
const SvgDrop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <g clipPath="">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M7.912 5.338a.583.583 0 0 0-.825 0l-3.3 3.3a.584.584 0 1 0 .825.825L7.5 6.575l2.887 2.888a.583.583 0 0 0 .825-.825l-3.3-3.3Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 14.5h14V.5H.5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDrop;
